import { createFileRoute } from "@tanstack/react-router";
import { Step3ServiceTerm } from "@/features/vendor/onboarding/v1/step-3-service-term";

export const Route = createFileRoute(
  "/vendors/onboarding/v1/step-3-service-term",
)({
  component: Step3ServiceTerm,
});
